import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const FAQ = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    question: 'Will I receive any training?',
    answer: 'At Great Eastern, we offer our Financial Representatives structured training programmes to address topics like prospecting, sales presentation and telephone etiquette. You will also receive guidance and coaching from our experienced and successful leaders and mentors.'
  }, {
    question: 'Is it all about sales?',
    answer: "A career as a Financial Representative is not just a product sales job. Your role is to help others achieve their financial goals through proper planning. Our proven career advancement pathway allows you to fast-track your career and move into a management position, where your primary role as a manager is to identify, nurture and develop future talent. In other words, you'll be an entrepreneur, running your own business. To do this, you'll demonstrate exceptional leadership abilities and bring out the best in your Financial Representatives."
  }, {
    question: 'How do I approach people?',
    answer: 'Approach potential customers with a view to helping them. Any family who has lost a loved one but has still been able to maintain their lifestyle through adequate insurance protection will tell you how important that help is. In any job you have to deal with rejection. But as an insurance professional, the potential for rejection will be reduced if your approach is helpful.'
  }, {
    question: 'Will I enjoy a stable income?',
    answer: "A career in financial planning allows you to maximise your earning potential and generate a stream of passive and perpetual income that will create financial stability. As a Financial Representative, your paycheck will correspond with your performance – and there's no limit. The income you earn may vary from month to month but is usually much higher than a regular salaried job."
  }, {
    question: 'Is becoming a Financial Representative a good career choice?',
    answer: 'Your family will become proud of the difference you make to the lives of others as you achieve success and recognition at work.'
  }, {
    question: 'Are there lots of exams?',
    answer: 'Similar to other types of professionals, Financial Representatives are required to pass the relevant pre-contract licensing exams to be certified. To ensure you are well-prepared, we will provide you with the following exam support: In-house tutorials, sample examination papers, examination clinics, 1-to-1 coaching, E-campus online mock questions.'
  }, {
    question: 'How can a Financial Representative help others?',
    answer: "You'll become skilled at analysing your customers' situations and will soon be able to offer solutions to meet unique financial objectives. As a result, our Financial Representatives enjoy a fulfilling and worthwhile career."
  }, {
    question: 'How do I know which financial solutions are right for me?',
    answer: 'Our advisors conduct a comprehensive needs assessment to identify your specific goals, risk tolerance, and time horizon. We consider your assets, liabilities, family situation, and future aspirations to create a personalized financial plan that aligns with your unique circumstances.'
  }, {
    question: 'How often should I review my financial plan?',
    answer: 'We recommend reviewing your financial plan annually or whenever you experience a major life change (marriage, new home, children, career change, etc.). Our advisors proactively reach out for regular reviews to ensure your strategy evolves with your needs.'
  }, {
    question: 'What makes Magnavera Group different from other financial advisory firms?',
    answer: 'Magnavera Group distinguishes itself through our commitment to education, ethics, and empowerment. We focus on building long-term relationships, not just transactions. Our advisors are recognized for their expertise (many achieving MDRT status) and are committed to continuous professional development to serve you better.'
  }];
  const categories = [{
    title: 'Career Questions',
    faqs: [0, 1, 2, 3, 4, 5, 6]
  }, {
    title: 'Client Questions',
    faqs: [7, 8, 9]
  }];
  return <div className="w-full" data-id="element-335">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-336">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-337"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-338">
          <h1 className="text-white font-bold mb-4" data-id="element-339">
            Frequently Asked Questions
          </h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-340">
            Find answers to common questions about our services and career
            opportunities.
          </p>
        </div>
      </section>
      {/* FAQ Content */}
      <section className="py-16" data-id="element-341">
        <div className="container mx-auto px-4" data-id="element-342">
          <div className="max-w-3xl mx-auto" data-id="element-343">
            {categories.map((category, categoryIndex) => <div key={categoryIndex} className="mb-12" data-id="element-344">
                <h2 className="font-bold mb-6" data-id="element-345">{category.title}</h2>
                <div className="space-y-4" data-id="element-346">
                  {category.faqs.map(faqIndex => <div key={faqIndex} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-347">
                      <button className="w-full flex justify-between items-center p-4 bg-white text-left font-semibold" onClick={() => toggleFaq(faqIndex)} data-id="element-348">
                        {faqs[faqIndex].question}
                        {openFaq === faqIndex ? <ChevronUpIcon size={20} className="flex-shrink-0 text-primary" data-id="element-349" /> : <ChevronDownIcon size={20} className="flex-shrink-0 text-primary" data-id="element-350" />}
                      </button>
                      <div className={`overflow-hidden transition-all duration-300 ${openFaq === faqIndex ? 'max-h-96' : 'max-h-0'}`} data-id="element-351">
                        <div className="p-4 bg-white border-t border-gray-200" data-id="element-352">
                          <p className="text-text-secondary" data-id="element-353">
                            {faqs[faqIndex].answer}
                          </p>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Still Have Questions */}
      <section className="py-16 bg-background" data-id="element-354">
        <div className="container mx-auto px-4 text-center" data-id="element-355">
          <h2 className="font-bold mb-6" data-id="element-356">Still Have Questions?</h2>
          <p className="text-text-secondary max-w-2xl mx-auto mb-8" data-id="element-357">
            Can't find the answer you're looking for? Please reach out to our
            friendly team.
          </p>
          <Button href="/contact" data-id="element-358">Contact Us</Button>
        </div>
      </section>
    </div>;
};
export default FAQ;